export const PresetStatusColorTypes = [
    'success',
    'processing',
    'error',
    'default',
    'warning',
];
export const PresetColorTypes = [
    'pink',
    'red',
    'yellow',
    'orange',
    'cyan',
    'green',
    'blue',
    'purple',
    'geekblue',
    'magenta',
    'volcano',
    'gold',
    'lime',
];
